import EventEmitter from "events";
import auth0 from "auth0-js";
import store from "../store";
import Vue from "vue";

const auth = new auth0.WebAuth({
  domain: process.env.VUE_APP_AUTH_DOMAIN,
  clientID: process.env.VUE_APP_AUTH_CLIENT_ID,
  redirectUri: process.env.VUE_APP_CALLBACK_URI,
  scope: "openid profile",
  responseType: "token id_token",
  cacheLocation: "localstorage",
  useRefreshTokens: true,
});

const localStorageKey = "Auth0loggedIn";

class AuthService extends EventEmitter {
  idToken = null;
  profile = null;
  tokenExpiry = null;
  profileportal = null;
  ParentCompany = null;

  themepref = localStorage.getItem("themepref");
  accessGroup = null;
  UserName = null;

  UserURN = null;
  userLocation = null;

  login(customState) {
    auth.authorize({
      appState: customState,
    });
  }

  locallogin(authResult) {
    var nickname = authResult.idTokenPayload.nickname;
    this.idToken = authResult.idToken;
    this.ParentCompany =
      authResult.idTokenPayload["http://agpms/parentcompany"];
    this.profile = authResult.idTokenPayload;
    this.profileportal = authResult.idTokenPayload["http://agpms/portal"];
    this.UserURN = authResult.idTokenPayload.sub;
    this.accessGroup = authResult.idTokenPayload["http://agpms/Authorise"];

    this.tokenExpiry = new Date(this.profile.exp * 1000);
    this.userLocation = authResult.idTokenPayload["http://agpms/location"];
    this.userCompany =
      authResult.idTokenPayload["http://agpms/UserPreferences"];

    localStorage.setItem("TokenExpiry", this.tokenExpiry);

    Vue.prototype.$tokenExpiry = this.tokenExpiry;

    if (this.themepref === null) {
      this.themepref = "dark";
    }

    Vue.prototype.$Nickname = nickname;
    Vue.prototype.$ProfilePortal = this.profileportal;
    Vue.prototype.$ThemePref = this.themepref;
    Vue.prototype.$AccessGroup = this.accessGroup;
    Vue.prototype.$FullName = this.profile.name;
    Vue.prototype.$UserURN = this.UserURN;
    Vue.prototype.$Location = this.userLocation;
    Vue.prototype.$Company = this.userCompany;
    Vue.prototype.$ParentCompany = this.ParentCompany;

    this.firstInitial = this.profile.name.substring(0, 1);
    this.secondName = this.profile.name.substring(
      this.profile.name.indexOf(" ") + 1
    );
    this.secondInitial = this.secondName.substring(0, 1);
    this.userInitials = this.firstInitial + this.secondInitial;
    localStorage.setItem("UserInitials", this.userInitials);

    localStorage.setItem("Nickname", nickname);
    localStorage.setItem(localStorageKey, "true");
    localStorage.setItem("profileportal", this.profileportal);
    localStorage.setItem("themepref", this.themepref);
    localStorage.setItem("accessGroup", this.accessGroup);
    localStorage.setItem("fullname", this.profile.name);
    localStorage.setItem("ParentCompany", this.ParentCompany);
    localStorage.setItem("UserURN", this.UserURN);
    localStorage.setItem("location", this.userLocation);
    localStorage.setItem("CurrentLocation", this.userLocation);

    localStorage.setItem("Company", this.userCompany);

    this.emit("loginEvent", {
      Auth0loggedIn: true,
      profile: this.profile,
      themepref: this.themepref,
      profileportal: this.profileportal,
      accessGroup: this.accessGroup,
      state: authResult.appState || {},
    });
    store.dispatch("updatePortalProfile", this.profileportal, { root: true });
    store.dispatch("setView", this.themepref, { root: true });
    store.dispatch("setAccess", this.accessGroup, { root: true });
  }

  handleAuthentication() {
    return new Promise((resolve, reject) => {
      auth.parseHash((err, authResult) => {
        if (err) reject(err);
        this.locallogin(authResult);
        return resolve();
      });
    });
  }

  isAuthenticated() {
    return (
      Date.now() < this.tokenExpiry &&
      localStorage.getItem(localStorageKey) === "true"
    );
  }

  renewTokens() {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem(localStorageKey) !== "true") {
        return reject(Error("Not Logged In"));
      }

      return auth.checkSession({}, (err, authResult) => {
        this.locallogin(authResult);
        return resolve();
      });
    });
  }

  logout() {
    localStorage.removeItem(localStorageKey);
    localStorage.removeItem("themepref");
    localStorage.removeItem("accessGroup");
    localStorage.removeItem("profileportal");
    localStorage.removeItem("theme");
    localStorage.removeItem("portalprofile");
    localStorage.removeItem("loggedin");
    localStorage.removeItem("fullname");
    localStorage.removeItem("UserURN");
    localStorage.removeItem("Nickname");
    localStorage.removeItem("cookieAccept");
    localStorage.removeItem("TokenExpiry");
    localStorage.removeItem("Company");
    localStorage.removeItem("location");
    localStorage.removeItem("CurrentLocation");
    localStorage.removeItem("UserInitials");
    localStorage.removeItem("ParentCompany");

    Vue.prototype.$Nickname = "";
    Vue.prototype.$ProfilePortal = "";
    Vue.prototype.$ThemePref = "";
    Vue.prototype.$AccessGroup = "";
    Vue.prototype.$FullName = "";
    Vue.prototype.$UserURN = "";
    Vue.prototype.$Location = "";
    Vue.prototype.$Company = "";
    Vue.prototype.$locations = "";
    Vue.prototype.$DeviceID = "";
    Vue.prototype.$DeviceVariant = "";
    Vue.prototype.$DetailToShow = "";
    Vue.prototype.$ParentCompany = "";

    this.idToken = null;
    this.profile = null;
    this.tokenExpiry = null;
    this.profileportal = null;
    this.accessGroup = null;
    this.themepref = null;
    this.ParentCompany = null;

    this.UserURN = null;

    auth.logout({
      returnTo: window.location.origin,
    });

    this.emit("loginEvent", { Auth0loggedIn: false });
  }
}
export default new AuthService();
